module.exports = __webpack_public_path__ + "static/media/img_Benchmarking402.75670063.png";